import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import handleValidDate from "../../../../helpers/utils/handleValidDate";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

//Import actions

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../../Components/Common/ExportDoc";
import { getAccAccount, getAccCategory, resetAccCategoryState } from "../../../../store/actions";
import Export from "./Export";

const BalanceSheet = () => {
  const dispatch = useDispatch();
  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, accCategories, isAccCategoryCreated, isAccCategorySuccess, loading, error, accAccounts, loadingAccAccounts } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    accCategories: state.AccCategory.accCategories,
    isAccCategoryCreated: state.AccCategory.isAccCategoryCreated,
    isAccCategorySuccess: state.AccCategory.isAccCategorySuccess,
    loading: state.AccCategory.loading,
    error: state.AccCategory.error,
    accAccounts: state.AccAccount.accAccounts,
    loadingAccAccounts: state.AccAccount.loading,
  }));

  const [dataTreeAccount, setDataTreeAccount] = useState([]);
  const [filterDate, setFilterDate] = useState({
    start: null,
    end: null,
  });

  const buildAccountTree = (items) => {
    const itemMap = new Map();
    const roots = [];

    items.forEach((item) => {
      // console.log(item, "okkkkkttt");

      const node = {
        id: item.id,
        name: item.name,
        code: item.code,
        sort_order: item.sort_order,
        type: item.type,

        parentId: item.parentId,
        childrens: [],
      };

      itemMap.set(item.id, node);

      if (item.parentId === null) {
        roots.push(node);
      }
    });

    items.forEach((item) => {
      if (item.parentId !== null) {
        const parentNode = itemMap.get(item.parentId);
        if (parentNode) {
          parentNode.childrens.push(itemMap.get(item.id));
        }
      }
    });

    roots.sort((a, b) => a.sort_order - b.sort_order);

    function sortChildren(node) {
      node.childrens.sort((a, b) => a.sort_order - b.sort_order);
      node.childrens.forEach(sortChildren);
    }

    roots.forEach(sortChildren);

    return roots;
  };

  function isDateBetween(dateToCheckString, startDateString, endDateString) {
    const dateToCheck = new Date(dateToCheckString);
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    if (isNaN(dateToCheck.getTime()) || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format provided.");
      return false;
    }

    return dateToCheck >= startDate && dateToCheck <= endDate;
  }

  function attachAccountsToTree(treeRoots, accounts, startDate = null, endDate = null) {
    const categoryMap = new Map();

    function collectCategories(node) {
      if (node.id) {
        categoryMap.set(node.id, node);
      }
      node.childrens.forEach(collectCategories);
    }

    treeRoots.forEach(collectCategories);

    accounts.forEach((account) => {
      const categoryId = account.categoryId;
      if (!categoryId) return;

      const targetCategory = categoryMap.get(categoryId);
      if (!targetCategory) {
        console.warn(`Kategori ID ${categoryId} tidak ditemukan di tree`);
        return;
      }

      let temp_saldo_close = 0;

      let valAccClose = "";
      if (Array.isArray(account.acc_account_close) && account.acc_account_close.length > 0) {
        valAccClose = account.acc_account_close[account.acc_account_close.length - 1];
      }

      let debitClose = valAccClose.debit ? parseFloat(valAccClose.debit) : 0;
      let creditClose = valAccClose.credit ? parseFloat(valAccClose.credit) : 0;

      if (debitClose > 0) temp_saldo_close += debitClose;
      if (creditClose > 0) temp_saldo_close -= creditClose;

      let headerSaldo = temp_saldo_close;

      for (const trx of account.acc_account_trans_detail || []) {
        let headerDebit = trx.debit ? parseFloat(trx.debit) : 0;
        let headerCredit = trx.credit ? parseFloat(trx.credit) : 0;

        if (startDate || endDate) {
          if (isDateBetween(handleValidDate(trx?.at_detail_trans?.transactionat, "YYYY/MM/DD"), startDate, endDate)) {
            if (headerDebit > 0) headerSaldo += headerDebit;
            if (headerCredit > 0) headerSaldo -= headerCredit;
          }
        }
        else {
          if (headerDebit > 0) headerSaldo += headerDebit;
          if (headerCredit > 0) headerSaldo -= headerCredit;
        }
      }

      const accountNode = {
        isAccount: true,
        id: account.id,
        name: account.name,
        code: account.code,
        headerSaldo: headerSaldo,
        updatedat: account.updatedat,
        childrens: [],
      };

      targetCategory.childrens.push(accountNode);
    });

    function sortChildrens(node) {
      node.childrens.sort((a, b) => {
        if (a.isAccount && !b.isAccount) return 1;
        if (!a.isAccount && b.isAccount) return -1;
        return a.code.localeCompare(b.code);
      });

      node.childrens.forEach(sortChildrens);
    }

    treeRoots.forEach(sortChildrens);

    return treeRoots;
  }

  // Relasi induk-anak akun tidak tersedia dari API, jadi dideteksi dari kode akun.
  // Induk = akun lain yang kodenya merupakan prefix dan paling panjang (induk terdekat).
  function attachAccountRollup(treeRoots) {
    const accounts = [];

    function collectAccounts(node) {
      if (node.isAccount) {
        accounts.push(node);
      }
      (node.childrens || []).forEach(collectAccounts);
    }

    treeRoots.forEach(collectAccounts);

    accounts.forEach((account) => {
      account.parentAccountId = null;
      account.childAccounts = [];
      account.hasChildren = false;
      account.rollupSaldo = account.headerSaldo || 0;
    });

    accounts.forEach((account) => {
      const code = (account.code || "").trim();
      if (!code) return;

      let parent = null;
      accounts.forEach((candidate) => {
        if (candidate === account) return;

        const candidateCode = (candidate.code || "").trim();
        if (!candidateCode || candidateCode.length >= code.length) return;
        if (!code.startsWith(candidateCode)) return;

        if (!parent || candidateCode.length > (parent.code || "").trim().length) {
          parent = candidate;
        }
      });

      if (parent) {
        account.parentAccountId = parent.id;
        parent.childAccounts.push(account);
      }
    });

    accounts.forEach((account) => {
      account.childAccounts.sort((a, b) => (a.code || "").trim().localeCompare((b.code || "").trim()));
    });

    function computeRollup(account) {
      const childTotal = account.childAccounts.reduce((sum, child) => sum + computeRollup(child), 0);

      account.rollupSaldo = (account.headerSaldo || 0) + childTotal;
      account.hasChildren = account.childAccounts.length > 0;

      return account.rollupSaldo;
    }

    accounts.forEach((account) => {
      if (!account.parentAccountId) computeRollup(account);
    });

    return treeRoots;
  }

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function formatSaldo(saldo) {
    const value = saldo || 0;
    return value < 0 ? `(${currencyFormat(Math.abs(value))})` : currencyFormat(value);
  }

  // Total hanya dihitung dari saldo masing-masing akun (bukan rollup) supaya tidak dobel hitung.
  function sumAccountsSaldo(node) {
    if (!node) return 0;
    if (node.isAccount) return node.headerSaldo || 0;
    return (node.childrens || []).reduce((sum, child) => sum + sumAccountsSaldo(child), 0);
  }

  function hasAccountDescendant(node) {
    return (node.childrens || []).some((child) => (child.isAccount ? true : hasAccountDescendant(child)));
  }

  // Akun yang punya induk tidak dirender di level ini, karena sudah dirender di bawah induknya.
  function visibleChildren(node) {
    return (node.childrens || []).filter((child) => !(child.isAccount && child.parentAccountId));
  }

  function renderAccountNode(account, depth) {
    return (
      <Fragment key={`acc-${account.id}`}>
        <div style={{ marginLeft: `${20 + depth * 20}px` }} className="border-bottom">
          <div className="p-2 d-flex justify-content-between align-items-center">
            <span className="me-3">
              {account.code} - {account.name}
            </span>
            <span className="d-flex align-items-center flex-shrink-0">
              <span className="text-end" style={{ minWidth: "160px" }}>
                {account.hasChildren ? formatSaldo(account.rollupSaldo) : ""}
              </span>
              <span className="text-end ms-3" style={{ minWidth: "150px" }}>
                {formatSaldo(account.headerSaldo)}
              </span>
            </span>
          </div>
        </div>
        {(account.childAccounts || []).map((child) => renderAccountNode(child, depth + 1))}
      </Fragment>
    );
  }

  function renderTreeNode(node, depth) {
    if (node.isAccount) {
      return renderAccountNode(node, depth);
    }

    const showGroupTotal = depth === 0 && hasAccountDescendant(node);

    return (
      <Fragment key={`group-${node.id}`}>
        <div style={{ marginLeft: `${20 + depth * 20}px` }} className="border-bottom">
          <div className="p-2 bg-light">
            <span className="fw-bold">{node.name}</span>
          </div>
        </div>
        {visibleChildren(node).map((child) => renderTreeNode(child, depth + 1))}
        {showGroupTotal && (
          <div style={{ marginLeft: `${20 + depth * 20}px` }} className="p-2 border-top border-bottom bg-light fw-bold d-flex justify-content-between align-items-center">
            <span>Total {node.name}</span>
            <span>{formatSaldo(sumAccountsSaldo(node))}</span>
          </div>
        )}
      </Fragment>
    );
  }

  useEffect(() => {
    dispatch(resetAccCategoryState());
    dispatch(getAccCategory({ companyId: companySelected?.value }));
    dispatch(getAccAccount({ companyId: companySelected?.value, branchId: branchSelected?.value, status: 2, trans: true }));
  }, [companySelected, branchSelected]);

  useEffect(() => {
    if (accCategories.length > 0 && accAccounts.length > 0) {
      const tree = buildAccountTree(accCategories);
      const updatedTree = attachAccountsToTree(tree, accAccounts, filterDate.start, filterDate.end);
      attachAccountRollup(updatedTree);

      const balanceSheetData = updatedTree.filter((item) => ["1", "2", "3"].includes(item.code));

      const aset = balanceSheetData[0];

      if (aset && aset.childrens && aset.childrens.length > 0) {
        const categories = aset.childrens.filter((item) => item.isAccount !== true);
        const accounts = aset.childrens.filter((item) => item.isAccount === true);

        categories.sort((a, b) => a.id - b.id);

        aset.childrens = [...categories, ...accounts];
      }
      setDataTreeAccount(balanceSheetData);
    }
  }, [accCategories, accAccounts, filterDate]);

  document.title = "Laporan Tanda Jadi Harian | Enterprise Resources Planning";
  return (
    <div className="page-content">
      {/* <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accTransList} /> */}
      <Container fluid>
        <BreadCrumb title="Neraca" pageTitle="Keuangan" loading={loading || loadingAccAccounts}>
          <div className="d-flex align-items-center">
            <div className="search-box me-2 mb-0">
              <Flatpickr
                className="form-control"
                id="datepicker-publish-input"
                placeholder="Pilih Tanggal"
                options={{
                  mode: "range",
                  dateFormat: "Y/m/d",
                }}
                onChange={(selectedDates, dateStr) => {
                  if (!dateStr) {
                    setFilterDate({ start: null, end: null });
                    return;
                  }

                  const [start, end] = dateStr.split(" to ");

                  setFilterDate({ start: start ? start : null, end: end ? end : null });
                }}
              />
              <i className="bx bx-calendar-alt search-icon"></i>
            </div>

            <Export data={dataTreeAccount} />
          </div>
        </BreadCrumb>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-1">
                {dataTreeAccount.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    <p></p>
                  </div>
                ) : (
                  <div className="p-3">
                    <div className="d-flex justify-content-end px-2 pb-2 border-bottom">
                      <span className="fw-semibold text-end" style={{ minWidth: "160px" }}>
                        Total
                      </span>
                      <span className="fw-semibold text-end ms-3" style={{ minWidth: "150px" }}>
                        Saldo
                      </span>
                    </div>

                    {dataTreeAccount.map((root, rootIndex) => (
                      <div key={rootIndex} className="mb-3">
                        <div className="fw-bold p-2 border-bottom">{root.name}</div>

                        {visibleChildren(root).map((child) => renderTreeNode(child, 0))}

                        <div className="p-2 border-top border-bottom bg-light fw-bold d-flex justify-content-between align-items-center">
                          <span>Total {root.name}</span>
                          <span>{formatSaldo(sumAccountsSaldo(root))}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BalanceSheet;
